import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GenerateSmartLockChallengeResData extends ApiGenericResponse {
    challengeCode: string;
    remainingSeconds: number;
    manualAuthorized: boolean = false;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ChallengeCode) this.challengeCode = obj.ChallengeCode;
        if (obj.RemainingSeconds) this.remainingSeconds = obj.RemainingSeconds;
        if (obj.ManualAuthorized) this.manualAuthorized = obj.ManualAuthorized;
    }
}
